// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductSupport_container__J8_A5","productSupport":"ProductSupport_productSupport__KfH2E","productSupport__headline":"ProductSupport_productSupport__headline__Xk2Vq"};